import { Layer } from 'grommet'
import { CSSProperties, ReactNode } from 'react'
import { ActiveTab } from '../common/ActiveTab'
import { ModalHeader } from '../common/Modal/ModalHeader'

type DrawerBaseProps = {
  position?: 'left' | 'right'
  title: string
  onClose: () => void
  header?: ReactNode
  children: ReactNode
  style?: CSSProperties
  wide?: boolean
}

// Variant 1: no tabs
type DrawerWithoutTabs = DrawerBaseProps & {
  options?: undefined
  setTab?: undefined
}

// Variant 2: tabs enabled – both required
type DrawerOption = string | { label: string; value: string; badge?: ReactNode }

type DrawerWithTabs = DrawerBaseProps & {
  options: DrawerOption[]
  setTab: (arg: string) => void
}

export type DrawerProps = DrawerWithoutTabs | DrawerWithTabs

export const SideDrawer = ({
  children,
  position = 'right',
  onClose,
  header,
  options,
  setTab,
  title,
  style,
  wide
}: DrawerProps) => {
  return (
    <Layer full="vertical" modal onClickOutside={onClose} onEsc={onClose} position={position}>
      <div
        className={`flex h-screen max-w-[100vw] flex-col overflow-auto ${wide ? 'md:w-[min(960px,100vw)]' : 'md:w-[min(620px,100vw)]'}`}
      >
        <div className="sticky top-0 z-10 bg-white">
          <ModalHeader onClose={onClose} pad="16px" title={title} />
          <div style={style}>
            {header}
            {options && <ActiveTab divider options={options} setActive={arg => setTab?.(arg)} />}
          </div>
        </div>
        <div className="min-h-0 flex-1">{children}</div>
      </div>
    </Layer>
  )
}
